/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';
import type { FetchResult } from 'react-apollo';

import user from 'js/lib/user';

import { Button } from '@coursera/cds-core';
import type { DismissCalendarItemResponse } from '@coursera/grpc-types-degreehome/coursera/proto/degreehome/v1beta1/degree_home_calendar_api';

import { WithDismissCalendarItemMutation } from 'bundles/degree-home/components/v2/Calendar';
import { useDegreeContext } from 'bundles/degree-home/components/v2/DegreeHomeContext';

import _t from 'i18n!nls/degree-home';

export const RestoreButtonContent: React.FunctionComponent<{
  disabled: boolean;
  dismissAction: () => Promise<void | FetchResult<DismissCalendarItemResponse>>;
  onClick: () => void;
  onError: () => void;
}> = ({ dismissAction, onClick, disabled, onError }) => {
  const { setRefetchRequired } = useDegreeContext();
  return (
    <Button
      variant="ghost"
      disabled={disabled}
      size="small"
      onClick={() => {
        dismissAction()
          .then((result) => {
            onClick();
            setRefetchRequired(true);
            return result;
          })
          .catch(() => {
            onError();
          });
      }}
    >
      {_t('Restore')}
    </Button>
  );
};

export const RestoreButton: React.FunctionComponent<{
  courseId: string;
  itemId: string;
  onClick: () => void;
  disabled: boolean;
  onError: () => void;
}> = ({ courseId, itemId, onClick, disabled, onError }) => {
  const { degreeId } = useDegreeContext();

  return (
    <WithDismissCalendarItemMutation userId={user.get().id} degreeId={degreeId} courseId={courseId} itemId={itemId}>
      {({ dismissAction }, { loading }) => {
        return (
          <RestoreButtonContent
            disabled={disabled || loading}
            dismissAction={dismissAction}
            onClick={onClick}
            onError={onError}
          />
        );
      }}
    </WithDismissCalendarItemMutation>
  );
};
